window.LayoutRightColumn = (function() {
    var selectors = {
        container: '#layout-right-column'
    };

    return {
        show: function () {
            $(selectors.container).removeClass('m-hidden');
        },
        hide: function () {
            $(selectors.container).addClass('m-hidden');
        }
    };
}());